import { DateTimeLocalizationInfo } from '@mews-framework/globalization';
import { TextKey } from '@mews-framework/localization';

export const monthNameKeys = [
    TextKey.MonthJanuary,
    TextKey.MonthFebruary,
    TextKey.MonthMarch,
    TextKey.MonthApril,
    TextKey.MonthMay,
    TextKey.MonthJune,
    TextKey.MonthJuly,
    TextKey.MonthAugust,
    TextKey.MonthSeptember,
    TextKey.MonthOctober,
    TextKey.MonthNovember,
    TextKey.MonthDecember,
] satisfies DateTimeLocalizationInfo['monthNames'];

export const monthShortNameKeys = [
    TextKey.MonthShortJanuary,
    TextKey.MonthShortFebruary,
    TextKey.MonthShortMarch,
    TextKey.MonthShortApril,
    TextKey.MonthShortMay,
    TextKey.MonthShortJune,
    TextKey.MonthShortJuly,
    TextKey.MonthShortAugust,
    TextKey.MonthShortSeptember,
    TextKey.MonthShortOctober,
    TextKey.MonthShortNovember,
    TextKey.MonthShortDecember,
] satisfies DateTimeLocalizationInfo['monthShortNames'];

export const dayNameKeys = [
    TextKey.DaySunday,
    TextKey.DayMonday,
    TextKey.DayTuesday,
    TextKey.DayWednesday,
    TextKey.DayThursday,
    TextKey.DayFriday,
    TextKey.DaySaturday,
] satisfies DateTimeLocalizationInfo['dayNames'];

export const dayShortNameKeys = [
    TextKey.DayShortSunday,
    TextKey.DayShortMonday,
    TextKey.DayShortTuesday,
    TextKey.DayShortWednesday,
    TextKey.DayShortThursday,
    TextKey.DayShortFriday,
    TextKey.DayShortSaturday,
] satisfies DateTimeLocalizationInfo['dayShortNames'];
